import { render } from "./HeroiconsSolidSelector.vue?vue&type=template&id=473fc556"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSelector.vue"]])

export default __exports__